import React, { useEffect, useState } from "react";
import "./toolsSoftware.css";
import { FaDownload, FaCube } from "react-icons/fa";
import { BASEURL } from "../../../constant/constant";

const toolsData = [
    {
        title: "Frontend Development",
        items: ["React JS", "Next.js", "HTML5", "CSS3", "JavaScript", "Tailwind CSS"],
    },
    {
        title: "Backend & APIs",
        items: ["Node.js", "Express.js", "REST APIs", "JWT Authentication", "Postman"],
    },
    {
        title: "Databases",
        items: ["MySQL", "MongoDB", "PostgreSQL", "Firebase"],
    },
    {
        title: "DevOps & Cloud",
        items: ["AWS", "Docker", "CI/CD", "Nginx", "Linux"],
    },
    {
        title: "IoT & Hardware",
        items: ["MQTT", "ESP32", "Arduino", "Modbus", "LoRa"],
    },
    {
        title: "Tools & Utilities",
        items: ["Git", "GitHub", "VS Code", "Jira", "Figma"],
    },
];
const tools = [
    {
        name: "Penpot",
        description:
            "Penpot is the web-based open-source design tool that bridges the gap between designers and developers.",
        download: "https://penpot.app/download",
    },
];

const ToolsSoftware = () => {

    const [tools, setTools] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);


    const fetchTools = async () => {
        try {
            const res = await fetch(
                `${BASEURL}/api/appinfo/getappinfo`,
                {
                    method: "GET",
                    redirect: "follow",
                }
            );
            const json = await res.json();
            if (json.success && Array.isArray(json.data)) {
                setTools(json.data);
            } else {
                setTools([]);
            }
        } catch (err) {
            console.error(err);
            setError("Failed to load tools");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchTools();
    }, []);
    if (loading) return <p>Loading tools...</p>;
    if (error) return <p style={{ color: "red" }}>{error}</p>;

    return (
        <>

            <div className="tools-wrapper">
                <header className="tools-header">
                    <h1>Tools & Software</h1>
                    <p>Technologies and platforms we use to build reliable solutions</p>
                </header>

                {/* <div className="tools-page">
                    <table className="tools-table">
                        <thead>
                            <tr>
                                <th>Software Tools</th>
                                <th>Description</th>
                                <th>Download Link</th>
                            </tr>
                        </thead>
                        <tbody>
                            {tools.map((tool) => (
                                <tr key={tool._id}>
                                    <td className="tool-name">
                                        {tool.icon ? (
                                            <img
                                                src={`${baseURL}${tool.icon}`}
                                                alt={tool.name}
                                                className="tool-icon-img"
                                            />
                                        ) : (
                                            <FaCube className="tool-icon-fallback" />
                                        )}
                                        <span>{tool.name}</span>
                                    </td>
                                    <td className="tool-desc">{tool.description}</td>
                                    <td className="tool-download">
                                        <a href={tool.link} target="_blank" rel="noreferrer">
                                            <FaDownload />
                                            <span>{tool.name.toLowerCase()}.download</span>
                                        </a>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div> */}

                <section className="tools-grid">
                    {tools.map((tool) => (
                        <div className="tool-card" key={tool._id}>
                            <div className="tool-card-header">
                                <div className="tool-card-img">
                                    {tool.icon ? (
                                        <img
                                            src={`${BASEURL}${tool.icon}`}
                                            alt={tool.name}
                                            className="tool-icon-img"
                                        />
                                    ) : (
                                        <FaCube className="tool-icon-fallback" />
                                    )}
                                </div>

                                <div className="tool-card-h3">
                                    <h3>{tool.name}</h3>
                                </div>
                            </div>
                            <div className="tool-card-span">
                                <span className="tool-desc">{tool.description}</span>
                            </div>
                            <hr/>
                            <div className="tool-card-a">
                                <a href={tool.link} target="_blank" rel="noreferrer">
                                    <FaDownload />
                                    <span>{tool.name.toLowerCase()}.download</span>
                                </a>
                            </div>
                        </div>
                    ))}
                </section>
            </div>

        </>
    );
};

export default ToolsSoftware;
